import React from 'react';
import { withRouter, Redirect, Route, Switch } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';

import { AppState } from '../store';
import { checkAuthState } from '../store/authentication/action';
import { GlobalStyle } from '../styles/styled-components/GlobalStyles';
import Login from './User/Login/Login';
import Logout from './User/Logout/Logout';
import Layout from '../hoc/Layout/Layout';
import ForgotPassword from './User/ForgotPassword/ForgotPassword';
import OTPVerification from './User/OTPVerification/OTPVerification';
import ChangePassword from './User/ChangePassword/ChangePassword';
import ChangePasswordSuccess from './User/ChangePasswordSuccess/ChangePasswordSuccess';
import Customers from './Customers/Customers';
import CustomerDetails from './CustomerDetails/CustomerDetails';
import { getUrlParams } from '../helpers/helpers';
import { defaultLang } from '../hoc/i18n/i18n';
import i18next from 'i18next';

interface AppProps {
  checkAuthState: () => void;
  isAuthenticated: boolean;
}

class App extends React.Component<AppProps & WithTranslation> {

  constructor(props: AppProps & WithTranslation) {
    super(props);
    const partner = getUrlParams().get('partner');
    if (partner) {
      localStorage.setItem('partner', partner);
      const lang = defaultLang();
      if (lang) {
        i18next.changeLanguage(lang);
      }
    }
  }

  componentDidMount() {
    this.props.checkAuthState();
  }

  render() {
    let routes = (
      <React.Fragment>
        <GlobalStyle />
        <Switch>
          <Route path="/" exact render={(props: any) => (
            <Login {...props} />
          )} />
          <Route path="/forgot-password" exact render={(props: any) => (
            <ForgotPassword {...props} />
          )} />
          <Route path="/verification" exact render={(props: any) => (
            <OTPVerification {...props} />
          )} />
          <Route path="/change-password" exact render={(props: any) => (
            <ChangePassword {...props} />
          )} />
          <Route path="/change-password-success" exact render={(props: any) => (
            <ChangePasswordSuccess {...props} />
          )} />
          <Route component={Login} />
        </Switch>
      </React.Fragment>
    );
    if (this.props.isAuthenticated) {
      routes = (
        <Switch>
          <Route path="/customers-management" exact component={Customers} />
          <Route path="/customer-details" exact component={CustomerDetails} />
          <Route path="/logout" exact render={() => (
            <Logout />
          )} />
          <Redirect from="/" exact to="/customers-management" />
        </Switch>
      );
    }

    return (
      <div className="App">
        <Layout isAuthenticated={this.props.isAuthenticated}>
          {routes}
        </Layout>
      </div>
    );
  }

}

const mapStateToProps = (state: AppState, ownProps: AppProps) => {
  return {
    isAuthenticated: state.authentication.token ? true : false,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    checkAuthState: () => dispatch(checkAuthState()),
  };
};

export default withRouter<any, any>(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(App)));